module.exports = __webpack_public_path__ + "img/cloud.54545e30.svg";